/* import __COLOCATED_TEMPLATE__ from './hardware-order-unavailable-dialog.hbs.js'; */
import Component from '@glimmer/component';

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class HardwareOrderUnavailableDialog extends Component {}